/**
 * The film format codes the backend knows (PAUL-3131), in the order a picker lists them. The backend never
 * translates a format: every frontend labels the codes itself, through `movieFormatCodeKey`. A Filmdepot label
 * nobody has mapped yet still arrives, as its own slug, so a code outside this list is shown by the format's
 * name rather than dropped.
 */
export const MOVIE_FORMAT_CODES: readonly string[] = [
  '2d',
  '3d',
  'imax',
  '4d',
  'screenx',
  'dolby-cinema',
  'dolby-vision',
  'dolby-atmos',
  'epic-hdr',
  '4k',
  '70mm',
  'audio-description',
  'hoh-subtitles',
  'english-subtitles',
  'dutch-subtitles',
  'expat',
  'sing-along',
  'interactive',
];

/** The common i18n key of a code's label: `movie_formats.codes.dolby_cinema` for `dolby-cinema`. */
export const movieFormatCodeKey = (code: string): string => `movie_formats.codes.${code.replace(/-/g, '_')}`;

export const isKnownMovieFormatCode = (code: string): boolean => MOVIE_FORMAT_CODES.includes(code);
